import { parseISO, getYear as baseGetYear } from "date-fns";

export const getYear = (date: string | Date) => {
  if (typeof date === "string") {
    return baseGetYear(parseISO(date));
  }

  return baseGetYear(date);
};
